import { api } from "./api";

const urlBase64ToUint8Array = (b64) => {
    const padding = "=".repeat((4 - (b64.length % 4)) % 4);
    const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
    return out;
};

export async function ensureServiceWorker() {
    if (!("serviceWorker" in navigator)) throw new Error("Service workers not supported");
    return navigator.serviceWorker.register("/sw.js");
}

export async function subscribeToPush({ reminderHourUtc = 15 } = {}) {
    if (!("Notification" in window) || !("PushManager" in window)) {
        throw new Error("Push notifications aren't supported in this browser.");
    }
    const reg = await ensureServiceWorker();
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("Permission denied");

    const { data: cfg } = await api.get("/push/config");
    if (!cfg?.public_key) throw new Error("Server push config missing");

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(cfg.public_key),
        });
    }
    await api.post("/push/subscribe", {
        subscription: sub.toJSON(),
        reminder_hour_utc: reminderHourUtc,
    });
    return sub.toJSON();
}

export async function unsubscribeFromPush() {
    if (!("serviceWorker" in navigator)) return;
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager?.getSubscription();
    if (sub) {
        const json = sub.toJSON();
        await api.post("/push/unsubscribe", { endpoint: json.endpoint }).catch(() => {});
        await sub.unsubscribe().catch(() => {});
    }
}

export async function getPushSubscription() {
    if (!("serviceWorker" in navigator)) return null;
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager?.getSubscription();
    return sub ? sub.toJSON() : null;
}
